import { NewlyCreatedFacet } from 'store/slices/ToolSlice/types';
import { ToggleButton, ToggleGroup } from 'components/Basic/ToggleGroup';
import { toggleManualToolDoneButtonState, toggleManualToolResetButtonState } from 'store/slices/ManualToolModal';
import { useDispatch } from 'react-redux';
import { AppDispatch } from 'store';
import { ModalFacetBox, HeadingAzimuth, ShadingWrap, CustomShading, ShadingLabel,
	WarningContainer, WarningText, DivPanelCount, SystemDivWrap, ArrayHeading, FlexTwoCol, HeightSpacingWrap } from './style';
import RowSpacing from '../FacetInputs/RowSpacing';
import { BASE_SHADING, DEFAULT_SHADING_VAL, KONVA_FACET_GROUP, MAX_CUSTOM_SHADING, MIN_CUSTOM_SHADING,
	PREDEFINED_SHADING_VALUES } from '../../constants';
import PitchSlider from './PitchSlider';
import { useEffect, useState } from 'react';
import { FacetPropsKeyValue, PitchWrap } from 'components/Slider/styles';
import { convertShading } from '../../util';

function AzimuthDiv(props: { azimuth: number }) {
	const roundedValue = !(props.azimuth == null) ? Math.round(props.azimuth) : 'N/A';
	return (
		<HeadingAzimuth className='nonmode-azimuth'>
			<label>Azimuth:</label> 
			<span>{roundedValue}</span>
		</HeadingAzimuth >
	);
}

function PanelsCountDiv(props: { panelsCount: number; className?: string; }) {
	return (

		<DivPanelCount className={props.className}>
			<label>Panels Count:</label>
			<span>{props.panelsCount} </span>
		</DivPanelCount >
	);
}

function SystemProductionDiv(props: { systemProduction: number; className?: string; }) {
	const roundedValue = Math.round(+props.systemProduction.toFixed(2));
	return (
		<DivPanelCount className={props.className}>
			<label>System Production:</label>
			<span>{roundedValue} kWh</span>
		</DivPanelCount>
	);
}

function SystemSize(props: { systemSize: number; className?: string; }) {
	const roundedValue = +props.systemSize.toFixed(2);
	return (
		<DivPanelCount className={props.className}>
			<label>System Size:</label>
			<span>{roundedValue} kW</span>
		</DivPanelCount>
	);
}

type Props = NewlyCreatedFacet & {
	groupSuffix: string;
	active?: boolean;
	systemSize?: number;
	systemProduction?: number;
	panelsCount?: number;
	onChange: (id: string, groupSuffix: string) => void;
	onShadingValChange(id: string, groupSuffix: string, value: any): void;
	onPitchValChange(id: string, groupSuffix: string, value: any): void;
	onRowSpacingValChange?(id: string, groupSuffix: string, value: any): void;
	previousPitch?: number;
	previousShading?: number;
	isEdited?: boolean;
	canEditFacetProps: boolean;
	totalPanelsFromFacet?: number; 
	totalPanelsProduction?: number;
	totalSystemSize?: number;
	showCompleteArrayDetails?: boolean;
};
export default function NonDefaultModeValues(props: Props) {
	const { azimuthDegrees, pitchDegrees, shading = DEFAULT_SHADING_VAL, rowSpacing, isGroundMount, noGapGroundMount, groupSuffix,
		systemProduction, systemSize, panelsCount, canEditFacetProps, totalPanelsFromFacet, totalPanelsProduction,
		totalSystemSize, showCompleteArrayDetails } = props;
	const isShadingPredefined = PREDEFINED_SHADING_VALUES.includes(shading);
	const [customShadingEnabled, setCustomShadingEnabled] = useState(!isShadingPredefined);
	const customShadingValue = isShadingPredefined ? MIN_CUSTOM_SHADING : +(shading-BASE_SHADING).toFixed(2); // Default to 0 if predefined
	const [customShading, setCustomShading] = useState(customShadingValue);
	const toggleGroupValue = PREDEFINED_SHADING_VALUES.includes(shading) ? shading.toString() : 'custom';

	useEffect(() => {
		const isPredefined = PREDEFINED_SHADING_VALUES.includes(shading);
		setCustomShadingEnabled(!isPredefined);
		setCustomShading(isPredefined ? MIN_CUSTOM_SHADING : +(shading - BASE_SHADING).toFixed(2));
	}, [shading]);
	console.log('shadingValue on rerender:', shading);
	const dispatch = useDispatch<AppDispatch>();

	function handleClick(){
		props.onChange(props.konvaPolygonId, props.groupSuffix);
	}

	function handleRowSpacingChange(value: number) {
		props.onRowSpacingValChange && props.onRowSpacingValChange(props.konvaPolygonId, props.groupSuffix, value);
		// value is NaN while the field is cleared mid-edit (see RowSpacing.tsx) - forward it so the
		// pending debounced write resets, but don't mark the facet edited for a non-final value
		if (Number.isNaN(value)) return;
		props.onChange(props.konvaPolygonId, props.groupSuffix);
		if (groupSuffix.slice(1) != KONVA_FACET_GROUP.IN_PROGRESS_GROUP_NAME) {
			dispatch(toggleManualToolDoneButtonState({ inputFieldsEdited: true }));
			dispatch(toggleManualToolResetButtonState({ resetEnabled: true }));
		}
	}

	// const validateShadingValue = (value: string) => {
	// 	const numValue = parseFloat(value);
	// 	return !isNaN(numValue) && numValue >= 0 && numValue <= 70;
	// };

	return (
		<>
			{
				<ModalFacetBox className={` ${props.active ? 'active de' : ''} ${props.isEdited ? 'edited' : ''}`} onClick={handleClick}>
					{/* <div className="facet-label_name">Facet A</div> */}
					<AzimuthDiv azimuth={azimuthDegrees!} />
					<SystemProductionDiv systemProduction={systemProduction ?? 0} />
					<FlexTwoCol>
						<SystemSize systemSize={systemSize ?? 0} />
						<PanelsCountDiv panelsCount={panelsCount ?? 0} />
					</FlexTwoCol>
					<div className='facet-slider-wrap facet-slider-slope-info 2' 
						style={{paddingTop: '2px'}}>
						{(pitchDegrees == undefined) ? (
							<PitchWrap className="pitch-label non-pitch-label">
								<label>Pitch: </label>
								<span>N/A</span>
							</PitchWrap>
						) : (
							canEditFacetProps ? 
								<PitchSlider
									pitch={pitchDegrees ?? (isGroundMount ? 18 : 20)}
									active= {!!props.active }
									onChange={(v) => {
										props.onPitchValChange(props.konvaPolygonId, props.groupSuffix, +v);
										props.onChange(props.konvaPolygonId, props.groupSuffix);
										if(groupSuffix.slice(1) != KONVA_FACET_GROUP.IN_PROGRESS_GROUP_NAME){
											dispatch(toggleManualToolDoneButtonState({ inputFieldsEdited: true }));
											dispatch(toggleManualToolResetButtonState({resetEnabled: true}));
										}
									}}
								/>
								:
								<FacetPropsKeyValue>
										Pitch:
									<span className="value">{Math.round(pitchDegrees ?? (isGroundMount ? 18 : 20))*100 / 100}</span>
								</FacetPropsKeyValue>

						)}
					</div>
					{
						canEditFacetProps ? (
							<>
								<ShadingWrap className='facet-slope-wrap facet-slider-slope-info'>
									<ShadingLabel>
										<span>Shading:</span>
									</ShadingLabel>
									<div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', position: 'relative' }}>
										<ToggleGroup
											value={toggleGroupValue}
											onChange={(v) => {
												console.log('Shading value selected:', v);
												if(v === 'custom') {
													console.log('Enabling custom shading input');
													setCustomShadingEnabled(true);
													v = (BASE_SHADING+MIN_CUSTOM_SHADING).toFixed(2);
												}
												else{
													setCustomShadingEnabled(false);
												}
												props.onShadingValChange(props.konvaPolygonId, props.groupSuffix, +v);
												props.onChange(props.konvaPolygonId, props.groupSuffix);
												if(groupSuffix.slice(1) != KONVA_FACET_GROUP.IN_PROGRESS_GROUP_NAME){
													dispatch(toggleManualToolDoneButtonState({ inputFieldsEdited: true }));
													dispatch(toggleManualToolResetButtonState({resetEnabled: true}));
												}
											}}
										>
											<ToggleButton value="14.08">None</ToggleButton>
											<ToggleButton value="15.85">low</ToggleButton>
											<ToggleButton value="20.28">medium</ToggleButton>
											<ToggleButton value="24.76">high</ToggleButton>
											<ToggleButton value="custom">Custom</ToggleButton>	
										</ToggleGroup>
										<CustomShading>
											{customShadingEnabled && (
												<input
													id="customShading"
													name="custom shading"
													type="number"
													min={MIN_CUSTOM_SHADING}
													max={MAX_CUSTOM_SHADING}
													step={0.1}
													value={customShading}
													// autoFocus={props?.active}
													onChange={(e) => {
														const val = +(e.target.value);
														console.log('Custom shading input:', val);
														setCustomShading(val);
														props.onChange(props.konvaPolygonId, props.groupSuffix);
														if(groupSuffix.slice(1) !== KONVA_FACET_GROUP.IN_PROGRESS_GROUP_NAME){
															dispatch(toggleManualToolDoneButtonState({ inputFieldsEdited: true }));
															dispatch(toggleManualToolResetButtonState({ resetEnabled: true }));
														}
													}}
													onBlur={(e) => {
														const val = +(Number(e.target.value).toFixed(2));
														console.log('Final Custom shading value:', val);
														props.onShadingValChange(props.konvaPolygonId, props.groupSuffix, +val+BASE_SHADING);
													}}
												/>
											)}
										</CustomShading>
									</div>
								</ShadingWrap>
								{(customShading < MIN_CUSTOM_SHADING || customShading > MAX_CUSTOM_SHADING) && (
									<WarningContainer>
										<WarningText>
								Please enter a shading value between {MIN_CUSTOM_SHADING}% and {MAX_CUSTOM_SHADING}%
										</WarningText>
									</WarningContainer>
								)}
							</>
						)
							:
							(
								<FacetPropsKeyValue>
										Shading:
									<span className="value">{convertShading(shading ? shading : DEFAULT_SHADING_VAL)}</span>
								</FacetPropsKeyValue>
							)
					}
					{
						isGroundMount && !noGapGroundMount && canEditFacetProps && (
							<HeightSpacingWrap>
								<RowSpacing value={rowSpacing} onChange={handleRowSpacingChange} singleField />
							</HeightSpacingWrap>
						)
					}
					{(showCompleteArrayDetails && (panelsCount != totalPanelsFromFacet)) &&
					<SystemDivWrap className={`${props.active ? 'active' : ''}`}>
						<ArrayHeading>Complete array details</ArrayHeading>
						<SystemProductionDiv className='array-detail-value array-production' systemProduction={totalPanelsProduction!} />
						<FlexTwoCol>
							<SystemSize className='array-detail-value' systemSize={totalSystemSize!} />
							<PanelsCountDiv className='array-detail-value' panelsCount={totalPanelsFromFacet!} />
						</FlexTwoCol>
					</SystemDivWrap>
					}

				</ModalFacetBox>
			}
		</>
	);

}
